import React from 'react'
import { Box, BoxProps } from 'rebass/styled-components'

export const LoadingBar = ({ children, sx, ...props }: BoxProps): JSX.Element => (
  <Box
    data-name="LoadingBar"
    sx={{ backgroundColor: 'grey100', borderRadius: '6px', height: '10px', width: '160px', maxWidth: '100%', ...sx }}
    {...props}
  >
    {children}
  </Box>
)
